import * as c from "react";
import { createContext as u } from "react";
import { w as f, r as l } from "./CSSMotionList.js";
var $ = /* @__PURE__ */ u({});
function d() {
}
let t = null;
function W() {
  t = null, l();
}
let p = d;
process.env.NODE_ENV !== "production" && (p = (e, a, n) => {
  f(e, `[antd: ${a}] ${n}`), process.env.NODE_ENV === "test" && W();
});
const x = /* @__PURE__ */ c.createContext({}), v = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: a
  } = c.useContext(x), n = (s, i, r) => {
    if (!s)
      if (a === !1 && i === "deprecated") {
        const o = t;
        t || (t = {}), t[e] = t[e] || [], t[e].includes(r || "") || t[e].push(r || ""), o || console.warn("[antd] There exists deprecated usage in your code:", t);
      } else
        process.env.NODE_ENV !== "production" && p(s, e, r);
  };
  return n.deprecated = (s, i, r, o) => {
    n(s, "deprecated", `\`${i}\` is deprecated. Please use \`${r}\` instead.${o ? ` ${o}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = d, e;
};
export {
  $ as I,
  x as W,
  v as d,
  p as w
};
